import { format, parseUrlDate } from '../utils/date/dateUtils';
import { urlUtils } from '../utils/url';

export const hotelOnlyModel = {
  get resortCaId() {
    const resortId = urlUtils.getResortIdFromUrl();
    return resortId === '-1' ? '' : resortId;
  },
  get resortWvId() {
    return urlUtils.getResortWvIdFromUrl();
  },
  get checkInDate() {
    const checkInDateFromUrl = urlUtils.getCheckInDateFromUrl();
    if (!checkInDateFromUrl) return null;

    const checkInDate = parseUrlDate(checkInDateFromUrl);
    return format(checkInDate, '-');
  },
  get checkoutDate() {
    const checkOutDateFromUrl = urlUtils.getCheckOutDateFromUrl();
    if (!checkOutDateFromUrl) return null;

    const checkOutDate = parseUrlDate(checkOutDateFromUrl);
    return format(checkOutDate, '-');
  },
  get Rooms() {
    return urlUtils.getRoomDistributionFromUrl();
  },
  get QueryUnits() {
    return urlUtils.getUnitsFromUrl();
  },
};

export const hotelOnlyPriceMatrix = {
  get resortCaId() {
    const resortId = urlUtils.getResortIdFromUrl();
    return resortId === '-1' ? '' : resortId;
  },
  get resortWvId() {
    return urlUtils.getResortWvIdFromUrl();
  },
  get hotelWvId() {
    return urlUtils.getHotelWvIdFromUrl();
  },
  get checkInDate() {
    const checkInDateFromUrl = urlUtils.getCheckInDateFromUrl();
    if (!checkInDateFromUrl) return null;

    const checkInDate = parseUrlDate(checkInDateFromUrl);
    return format(checkInDate, '-');
  },
  get checkoutDate() {
    const checkOutDateFromUrl = urlUtils.getCheckOutDateFromUrl();
    if (!checkOutDateFromUrl) return null;

    const checkOutDate = parseUrlDate(checkOutDateFromUrl);
    return format(checkOutDate, '-');
  },
  get Rooms() {
    return urlUtils.getRoomDistributionFromUrl();
  },
  get hotelCode() {
    return urlUtils.getHotelCodeFromUrl();
  },
  get selectedKey() {
    return urlUtils.getAccommodationKeyFromUrl();
  },
  get sessionId() {
    return urlUtils.getSessionIdFromUrl();
  },
};
